/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function GradientRadialClosestSide(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'GradientRadialClosestSide',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"opacity":".6","fillRule":"evenodd","clipRule":"evenodd","d":"M1 3v12h14V3h-1v11H2V3H1z","fill":"currentColor"}),createElement('path', {"opacity":".4","fillRule":"evenodd","clipRule":"evenodd","d":"M8 4.5a2.5 2.5 0 11-3 0V2H3.337A5.53 5.53 0 002 3.337v6.326A5.5 5.5 0 109.663 2H8v2.5z","fill":"currentColor"}),createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M1 1h14v1H7v2.05a2.51 2.51 0 00-1 0V2H1V1z","fill":"currentColor"}),createElement('circle', {"cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(5 5)","fill":"currentColor"}))
}
